import React, { useRef } from "react";
import { useField } from "formik";
import { FieldError } from "../Fields/Field";
import TextInputButton from "../Fields/TextInputButton";

const DonationInput = () => {
    const [{ onBlur, ...field }, meta] = useField({
        name: "Donation_Amount",
        value: "",
    });

    const txtInputBtnRef = useRef();

    const fieldProps = {
        ...field,
        id: "Donation-Amount",
        handleBlur: onBlur,
        onChange: (e, QMask) => {
            const currentTarget = QMask.el.input;
            const { name } = currentTarget;
            const value = QMask.unmaskedValue;

            field.onChange({ target: { name, value } });
        },
        labelText: "Donation Amount",
        type: "currency",
        selectable: false,
        txtInputBtnRef,
        centeredDisplay: false,
        alwaysDisplayPlaceholder: true,
    };

    return (
        <>
            <TextInputButton {...fieldProps} />
            <FieldError {...meta} />
        </>
    );
};

export default DonationInput;
